/* ==========================================================
   THE SIMPLE DATE - SHOP
   JUST-BROWSING SHOP / CART / SUBSCRIPTION ENGINE
   ========================================================== */

(() => {
  'use strict';


  /* ========================================================
     ROOT
     ======================================================== */

  const root =
    document.querySelector(
      'section.tsd-shop[id^="TSD-Shop-"]'
    );

  if (!root) return;


  /* ========================================================
     LOCKED ECONOMICS
     ======================================================== */

  const CONFIG = {
    freeShippingThreshold: 4000,
    fivePercentThreshold: 6000,
    tenPercentThreshold: 8000,

    subscriptionFirstDiscount: 20,
    subscriptionRecurringDiscount: 12,

    sellingPlanId: 2962784427
  };


  /* ========================================================
     ELEMENTS
     ======================================================== */

  const productCards =
    Array.from(
      root.querySelectorAll(
        '.tsd-product-card'
      )
    );


  const selectedContainer =
    root.querySelector(
      '[id^="TSD-Selected-Products-"]'
    );


  const barCountEl =
    root.querySelector(
      '[id^="TSD-Bar-Count-"]'
    );


  const subtotalEl =
    root.querySelector(
      '[id^="TSD-Subtotal-"]'
    );


  const addButton =
    root.querySelector(
      '[id^="TSD-Add-To-Cart-"]'
    );


  const savingsBox =
    root.querySelector(
      '.tsd-selection-box__savings'
    );
      const shopSidebar =
    root.querySelector(
      '.tsd-shop__sidebar'
    );

  const mobileQuery =
    window.matchMedia(
      '(max-width: 749px)'
    );


  /* ========================================================
     PRODUCT MODAL
     ======================================================== */

  const productModal =
    document.createElement(
      'div'
    );

  productModal.className =
    'tsd-shop-product-modal';

  productModal.setAttribute(
    'aria-hidden',
    'true'
  );

  productModal.innerHTML = `
    <div
      class="tsd-shop-product-modal__backdrop"
      data-tsd-shop-modal-close
    ></div>

    <div
      class="tsd-shop-product-modal__dialog"
      role="dialog"
      aria-modal="true"
      aria-label="Product details"
    >
      <button
        type="button"
        class="tsd-shop-product-modal__close"
        data-tsd-shop-modal-close
        aria-label="Close product details"
      >&times;</button>

      <div class="tsd-shop-product-modal__content">
        <div class="tsd-shop-product-modal__media">
          <div
            class="tsd-shop-product-modal__thumbs"
            data-tsd-shop-modal-thumbs
          ></div>

          <div class="tsd-shop-product-modal__stage">
            <button
              type="button"
              class="tsd-shop-product-modal__arrow tsd-shop-product-modal__arrow--prev"
              data-tsd-shop-modal-prev
              aria-label="Previous product image"
            >&#8249;</button>

            <img
              class="tsd-shop-product-modal__image"
              data-tsd-shop-modal-image
              src=""
              alt=""
            >

            <button
              type="button"
              class="tsd-shop-product-modal__arrow tsd-shop-product-modal__arrow--next"
              data-tsd-shop-modal-next
              aria-label="Next product image"
            >&#8250;</button>
          </div>
        </div>

        <div class="tsd-shop-product-modal__info">
          <p class="tsd-shop-product-modal__eyebrow">
            MEET THIS DATE
          </p>

          <h2
            class="tsd-shop-product-modal__title"
            data-tsd-shop-modal-title
          ></h2>

          <p
            class="tsd-shop-product-modal__flavor"
            data-tsd-shop-modal-flavor
          ></p>

          <p
            class="tsd-shop-product-modal__price"
            data-tsd-shop-modal-price
          ></p>

          <div
            class="tsd-shop-product-modal__description"
            data-tsd-shop-modal-description
          ></div>

          <div class="tsd-shop-product-modal__quantity-wrap">
            <span class="tsd-shop-product-modal__quantity-label">
              ADD TO YOUR CART
            </span>

            <div class="tsd-shop-product-modal__quantity">
              <button
                type="button"
                class="tsd-shop-product-modal__qty-button"
                data-tsd-shop-modal-minus
                aria-label="Decrease quantity"
              >&minus;</button>

              <span
                class="tsd-shop-product-modal__qty-value"
                data-tsd-shop-modal-quantity
                aria-live="polite"
              >0</span>

              <button
                type="button"
                class="tsd-shop-product-modal__qty-button"
                data-tsd-shop-modal-plus
                aria-label="Increase quantity"
              >+</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  root.appendChild(
    productModal
  );

  const modalState = {
    card: null,
    previousFocus: null,
    images: [],
    activeImage: 0
  };


  /* ========================================================
     SESSION PERSISTENCE
     ======================================================== */

  const STORAGE_KEY =
    'tsd-shop-session-v1';


  function readSavedState() {
    try {
      const raw =
        window.sessionStorage.getItem(
          STORAGE_KEY
        );

      if (!raw) {
        return null;
      }

      const saved =
        JSON.parse(raw);

      if (
        !saved ||
        !Array.isArray(saved.items)
      ) {
        return null;
      }

      return saved;

    } catch (error) {
      console.warn(
        'TSD Shop: could not restore saved state.',
        error
      );

      return null;
    }
  }


  const savedState =
    readSavedState();


  /* ========================================================
     STATE
     ======================================================== */

  const state = {

    purchaseType:
      savedState &&
      savedState.purchaseType ===
        'subscription'
        ? 'subscription'
        : 'onetime',

    items:
      new Map(
        savedState
          ? savedState.items
              .filter((item) => {
                return (
                  item &&
                  item.variantId &&
                  Number(item.quantity) > 0
                );
              })
              .map((item) => {

                const variantId =
                  String(
                    item.variantId
                  );

                return [
                  variantId,
                  {
                    variantId,

                    title:
                      item.title ||
                      'Chocolate Bar',

                    price:
                      Number(
                        item.price || 0
                      ),

                    flavor:
                      item.flavor ||
                      '',

                    image:
                      item.image ||
                      '',

                    quantity:
                      Math.max(
                        1,
                        Math.floor(
                          Number(
                            item.quantity
                          ) || 1
                        )
                      )
                  }
                ];
              })
          : []
      )
  };

  /* ========================================================
     MOBILE VIEW-DATES STICKY BAR
     ======================================================== */

  function isMobile() {
    return mobileQuery.matches;
  }


  function injectShopMobileStickyStyles() {

    if (
      document.getElementById(
        'tsd-shop-mobile-sticky-styles'
      )
    ) {
      return;
    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'tsd-shop-mobile-sticky-styles';


    style.textContent = `
      @media screen and (max-width: 749px) {

        .tsd-shop-mobile-sticky {
          position: fixed;
          z-index: 9990;

          left: 12px;
          right: 12px;

          bottom:
            calc(
              78px +
              env(safe-area-inset-bottom)
            );

          display: grid;

          grid-template-columns:
            minmax(0, 1fr)
            auto;

          gap: 10px;

          align-items: center;

          padding:
            11px
            12px;

          border:
            1px solid
            rgba(
              41,
              37,
              47,
              0.13
            );

          border-radius:
            16px;

          background:
            rgba(
              255,
              255,
              255,
              0.97
            );

          color:
            #29252f;

          box-shadow:
            0
            10px
            30px
            rgba(
              41,
              37,
              47,
              0.16
            );

          backdrop-filter:
            blur(10px);

          -webkit-backdrop-filter:
            blur(10px);

          opacity: 0;

          transform:
            translateY(14px);

          pointer-events:
            none;

          transition:
            opacity
            160ms
            ease,
            transform
            160ms
            ease;
        }


        .tsd-shop-mobile-sticky.is-visible {
          opacity: 1;

          transform:
            translateY(0);

          pointer-events:
            auto;
        }


        .tsd-shop-mobile-sticky__copy {
          min-width: 0;
        }


        .tsd-shop-mobile-sticky__status {
          display: block;

          color:
            #29252f;

          font-size:
            12px;

          line-height:
            1.2;

          font-weight:
            800;

          letter-spacing:
            0.025em;
        }


        .tsd-shop-mobile-sticky__button {
          min-width:
            82px;

          min-height:
            38px;

          padding:
            8px
            11px;

          border: 0;

          border-radius:
            999px;

          background:
            #ff33a7;

          color:
            #ffffff;

          cursor:
            pointer;

          font-size:
            9.5px;

          line-height:
            1.1;

          font-weight:
            800;

          letter-spacing:
            0.025em;

          white-space:
            nowrap;
        }


        body.tsd-shop-modal-open
        .tsd-shop-mobile-sticky {
          display:
            none !important;
        }

      }
/* Hide Shop sticky CTA while Shopify mobile menu is open */
body:has(#Details-menu-drawer-container[open])
.tsd-shop-mobile-sticky {
  display: none !important;
}

      @media screen and (max-width: 390px) {

        .tsd-shop-mobile-sticky {
          left: 8px;
          right: 8px;

          bottom:
            calc(
              74px +
              env(safe-area-inset-bottom)
            );

          padding:
            10px;
        }


        .tsd-shop-mobile-sticky__status {
          font-size:
            11px;
        }


        .tsd-shop-mobile-sticky__button {
          min-width:
            76px;

          padding-left:
            9px;

          padding-right:
            9px;
        }

      }
    `;


    document.head.appendChild(
      style
    );
  }


  function ensureShopMobileStickyBar() {

    let sticky =
      root.querySelector(
        '[data-tsd-shop-mobile-sticky]'
      );


    if (sticky) {
      return sticky;
    }


    sticky =
      document.createElement(
        'div'
      );


    sticky.className =
      'tsd-shop-mobile-sticky';


    sticky.setAttribute(
      'data-tsd-shop-mobile-sticky',
      ''
    );


    sticky.setAttribute(
      'aria-live',
      'polite'
    );


    sticky.innerHTML = `
      <div
        class="tsd-shop-mobile-sticky__copy"
      >
        <span
          class="tsd-shop-mobile-sticky__status"
          data-tsd-shop-mobile-sticky-status
        ></span>
      </div>

      <button
        type="button"
        class="tsd-shop-mobile-sticky__button"
        data-tsd-shop-mobile-sticky-button
      >
        VIEW DATES
      </button>
    `;


    root.appendChild(
      sticky
    );


    function scrollToDates() {

      if (!shopSidebar) {
        return;
      }


      const header =
        document.querySelector(
          'sticky-header, .header-wrapper, .shopify-section-header-sticky'
        );


      const headerHeight =
        header
          ? header
              .getBoundingClientRect()
              .height
          : 0;


      const breathingRoom =
        14;


      const targetTop =
        shopSidebar
          .getBoundingClientRect()
          .top +
        window.scrollY -
        headerHeight -
        breathingRoom;


      window.scrollTo({
        top:
          Math.max(
            0,
            targetTop
          ),

        behavior:
          'smooth'
      });
    }


    const button =
      sticky.querySelector(
        '[data-tsd-shop-mobile-sticky-button]'
      );


    if (button) {

      button.addEventListener(
        'click',
        (event) => {

          event.preventDefault();

          event.stopPropagation();

          scrollToDates();
        }
      );
    }


    sticky.addEventListener(
      'click',
      (event) => {

        if (
          event.target.closest(
            '[data-tsd-shop-mobile-sticky-button]'
          )
        ) {
          return;
        }


        scrollToDates();
      }
    );


    return sticky;
  }


  function updateShopMobileStickyBar() {

    const sticky =
      ensureShopMobileStickyBar();


    if (!sticky) {
      return;
    }


    const statusEl =
      sticky.querySelector(
        '[data-tsd-shop-mobile-sticky-status]'
      );


    const bars =
      getTotalBars();


    if (statusEl) {

      if (bars <= 0) {

        statusEl.textContent =
          'START PICKING YOUR DATES';

      } else {

        statusEl.textContent =
          `${bars} ${
            bars === 1
              ? 'DATE'
              : 'DATES'
          } SELECTED`;
      }
    }


    updateShopStickyVisibility();
  }


  function updateShopStickyVisibility() {

    const sticky =
      root.querySelector(
        '[data-tsd-shop-mobile-sticky]'
      );


    if (!sticky) {
      return;
    }


    if (!isMobile()) {

      sticky.classList.remove(
        'is-visible'
      );

      return;
    }


    if (!shopSidebar) {

      sticky.classList.remove(
        'is-visible'
      );

      return;
    }


    const rect =
      shopSidebar
        .getBoundingClientRect();


    const sidebarVisible =
      rect.bottom > 40 &&
      rect.top <
        window.innerHeight - 40;


    sticky.classList.toggle(
      'is-visible',
      !sidebarVisible
    );
  }


  function refreshShopMobileSticky() {

    updateShopMobileStickyBar();

    window.requestAnimationFrame(
      () => {

        updateShopStickyVisibility();
      }
    );
  }
  /* ========================================================
     SAVE STATE
     ======================================================== */

  function saveState() {
    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          purchaseType:
            state.purchaseType,

          items:
            Array.from(
              state.items.values()
            )
        })
      );

    } catch (error) {
      console.warn(
        'TSD Shop: could not save state.',
        error
      );
    }
  }


  /* ========================================================
     MONEY
     ======================================================== */

  function money(cents) {
    const amount =
      Number(cents || 0) / 100;

    return new Intl.NumberFormat(
      'en-CA',
      {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ).format(amount);
  }


  /* ========================================================
     SAFE HTML
     ======================================================== */

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  /* ========================================================
     ITEM HELPERS
     ======================================================== */

  function getItem(variantId) {
    return state.items.get(
      String(variantId)
    );
  }


  function getTotalBars() {
    let count = 0;

    state.items.forEach(
      (item) => {
        count += item.quantity;
      }
    );

    return count;
  }


  function getRetailSubtotal() {
    let subtotal = 0;

    state.items.forEach(
      (item) => {
        subtotal +=
          item.price *
          item.quantity;
      }
    );

    return subtotal;
  }


  function getOneTimeDiscountPercent(
    subtotal
  ) {
    if (
      subtotal >=
      CONFIG.tenPercentThreshold
    ) {
      return 10;
    }

    if (
      subtotal >=
      CONFIG.fivePercentThreshold
    ) {
      return 5;
    }

    return 0;
  }


  function getOneTimePrice(
    subtotal
  ) {
    const discount =
      getOneTimeDiscountPercent(
        subtotal
      );

    return Math.round(
      subtotal *
      (1 - discount / 100)
    );
  }


  function getSubscriptionFirstPrice(
    subtotal
  ) {
    return Math.round(
      subtotal *
      (
        1 -
        CONFIG.subscriptionFirstDiscount /
        100
      )
    );
  }


  function getSubscriptionRecurringPrice(
    subtotal
  ) {
    return Math.round(
      subtotal *
      (
        1 -
        CONFIG.subscriptionRecurringDiscount /
        100
      )
    );
  }


  /* ========================================================
     DISPLAY HELPERS
     ======================================================== */

  const FLAVOR_BY_TITLE = {
    'The Rich Date':
      '70% Vegan Dark',

    'The Sweet Date':
      'Milk Chocolate',

    'The Nutty Date':
      'Toasted Almond',

    'The Pista-Show Off Date':
      'Pistachio',

    'The Peanut Better Date':
      'Peanut Butter',

    'The Cash-oooh Date':
      'Cashew',

    'The Gutsy Date':
      'Nuts & Seeds',

    'The Naked Date':
      'Plain Medium Dark',

    'The Brazilian Nut Lift Date':
      'Brazil Nuts',

    'Monthly Blind Date':
      'Mystery'
  };


  const PRODUCT_HANDLE_BY_TITLE = {
    'The Rich Date':
      'naturally-date-sweetened-no-sugar-added-dark-chocolate',

    'The Sweet Date':
      'date-sweetened-no-refined-sugar-milk-chocolate-bar',

    'The Nutty Date':
      'date-sweetened-no-sugar-almond-chocolate-bar',

    'The Pista-Show Off Date':
      'naturally-date-sweetened-no-sugar-pistachio-chocolate-bar',

    'The Pista\u2013Show Off Date':
      'naturally-date-sweetened-no-sugar-pistachio-chocolate-bar',

    'The Peanut Better Date':
      'no-added-sugar-dates-peanut-butter-chocolate',

    'The Cash-oooh Date':
      'healthy-no-refined-sugar-cashew-chocolate-bar-dates',

    'The Cash\u2013oooh Date':
      'healthy-no-refined-sugar-cashew-chocolate-bar-dates',

    'The Gutsy Date':
      'date-sweetened-no-sugar-nuts-seeds-chocolate-bar',

    'The Naked Date':
      'the-naked-date',

    'The Brazilian Nut Lift Date':
      'the-brazilian-nut-lift-date',

    'The Blind Date':
      'mystery-flavour-date-sweetened-chocolate',

    'Monthly Blind Date':
      'mystery-flavour-date-sweetened-chocolate'
  };


  const productDetailCache =
    new Map();


  function getFlavorName(
    card,
    title
  ) {

    const mapped =
      FLAVOR_BY_TITLE[title];

    if (mapped) {
      return mapped;
    }


    if (card) {

      const flavorEl =
        card.querySelector(
          '[data-product-flavor], [data-product-flavour], .tsd-product-card__flavor, .tsd-product-card__flavour, .tsd-product-card__subtitle'
        );

      if (flavorEl) {

        const text =
          flavorEl.textContent.trim();

        if (text) {
          return text;
        }
      }
    }


    return (
      title ||
      'Chocolate Bar'
    );
  }


  function getCardImage(card) {

    if (!card) {
      return '';
    }


    const image =
      card.querySelector(
        'img'
      );

    if (!image) {
      return '';
    }


    return (
      image.currentSrc ||
      image.src ||
      image.getAttribute('src') ||
      ''
    );
  }


  function getCardByVariantId(
    variantId
  ) {

    return (
      productCards.find(
        (card) => {
          return (
            String(
              card.dataset.variantId
            ) ===
            String(variantId)
          );
        }
      ) ||
      null
    );
  }


  function getProductHandle(
    card,
    title
  ) {

    if (!card) {
      return '';
    }


    const explicitHandle =
      card.dataset.productHandle ||
      card.dataset.handle ||
      '';


    if (explicitHandle) {
      return explicitHandle;
    }


    const productLink =
      card.querySelector(
        'a[href*="/products/"]'
      );


    if (productLink) {

      const href =
        productLink.getAttribute(
          'href'
        ) || '';


      const match =
        href.match(
          /\/products\/([^/?#]+)/
        );


      if (
        match &&
        match[1]
      ) {

        return match[1];
      }
    }


    return (
      PRODUCT_HANDLE_BY_TITLE[
        title
      ] ||
      ''
    );
  }


  async function loadProductDetails(
    card,
    title
  ) {

    const handle =
      getProductHandle(
        card,
        title
      );


    if (!handle) {
      return null;
    }


    if (
      productDetailCache.has(
        handle
      )
    ) {

      return productDetailCache.get(
        handle
      );
    }


    const request =
      fetch(
        `${getShopRoot()}products/${encodeURIComponent(handle)}.js`,
        {
          method:
            'GET',

          headers: {
            Accept:
              'application/json'
          },

          credentials:
            'same-origin'
        }
      )
        .then(
          async (response) => {

            if (!response.ok) {

              throw new Error(
                `Could not load product details (${response.status})`
              );
            }


            return response.json();
          }
        )
        .catch(
          (error) => {

            console.warn(
              'TSD Shop modal: richer Shopify product details could not be loaded.',
              error
            );


            return null;
          }
        );


    productDetailCache.set(
      handle,
      request
    );


    return request;
  }


  function normalizeProductImages(
    product,
    fallbackImage
  ) {

    const rawImages =
      product &&
      Array.isArray(
        product.images
      )
        ? product.images
        : [];


    const images =
      rawImages
        .map(
          (image) => {

            if (
              typeof image ===
              'string'
            ) {

              return image;
            }


            if (
              image &&
              typeof image ===
              'object'
            ) {

              return (
                image.src ||
                image.url ||
                ''
              );
            }


            return '';
          }
        )
        .filter(
          Boolean
        );


    if (
      !images.length &&
      fallbackImage
    ) {

      images.push(
        fallbackImage
      );
    }


    return Array.from(
      new Set(
        images
      )
    );
  }


  function sanitizeDescriptionHtml(
    html
  ) {

    const template =
      document.createElement(
        'template'
      );


    template.innerHTML =
      String(
        html ||
        ''
      );


    template.content
      .querySelectorAll(
        'script, style, iframe, object, embed, form'
      )
      .forEach(
        (node) => {
          node.remove();
        }
      );


    template.content
      .querySelectorAll('*')
      .forEach(
        (node) => {

          Array.from(
            node.attributes
          ).forEach(
            (attribute) => {

              if (
                /^on/i.test(
                  attribute.name
                )
              ) {

                node.removeAttribute(
                  attribute.name
                );
              }
            }
          );
        }
      );


    return template.innerHTML;
  }


  function renderModalGallery(
    images,
    title
  ) {

    const imageEl =
      productModal.querySelector(
        '[data-tsd-shop-modal-image]'
      );


    const thumbsEl =
      productModal.querySelector(
        '[data-tsd-shop-modal-thumbs]'
      );


    const previousButton =
      productModal.querySelector(
        '[data-tsd-shop-modal-prev]'
      );


    const nextButton =
      productModal.querySelector(
        '[data-tsd-shop-modal-next]'
      );


    modalState.images =
      Array.isArray(images)
        ? images
        : [];


    if (
      !modalState.images.length
    ) {

      modalState.activeImage =
        0;

      if (imageEl) {
        imageEl.removeAttribute(
          'src'
        );
      }

      if (thumbsEl) {
        thumbsEl.innerHTML =
          '';
      }

      if (previousButton) {
        previousButton.hidden =
          true;
      }

      if (nextButton) {
        nextButton.hidden =
          true;
      }

      return;
    }


    modalState.activeImage =
      Math.max(
        0,
        Math.min(
          modalState.activeImage,
          modalState.images.length - 1
        )
      );


    const activeImage =
      modalState.images[
        modalState.activeImage
      ];


    if (imageEl) {

      imageEl.src =
        activeImage;

      imageEl.alt =
        title ||
        'Chocolate bar';
    }


    if (thumbsEl) {

      thumbsEl.innerHTML =
        '';


      modalState.images.forEach(
        (image, index) => {

          const button =
            document.createElement(
              'button'
            );


          button.type =
            'button';


          button.className =
            'tsd-shop-product-modal__thumb';


          button.classList.toggle(
            'is-active',
            index ===
              modalState.activeImage
          );


          button.setAttribute(
            'data-tsd-shop-modal-thumb',
            String(index)
          );


          button.setAttribute(
            'aria-label',
            `View image ${index + 1}`
          );


          button.innerHTML = `
            <img
              src="${escapeHtml(image)}"
              alt=""
              loading="lazy"
            >
          `;


          thumbsEl.appendChild(
            button
          );
        }
      );
    }


    const hasMultipleImages =
      modalState.images.length > 1;


    if (previousButton) {
      previousButton.hidden =
        !hasMultipleImages;
    }


    if (nextButton) {
      nextButton.hidden =
        !hasMultipleImages;
    }
  }


  function showModalImage(
    index
  ) {

    if (
      !modalState.images.length
    ) {

      return;
    }


    let safeIndex =
      Number(index);


    if (
      !Number.isFinite(
        safeIndex
      )
    ) {

      safeIndex =
        0;
    }


    if (safeIndex < 0) {

      safeIndex =
        modalState.images.length - 1;
    }


    if (
      safeIndex >=
      modalState.images.length
    ) {

      safeIndex =
        0;
    }


    modalState.activeImage =
      safeIndex;


    const title =
      modalState.card
        ? modalState.card.dataset.productTitle ||
          'Chocolate Bar'
        : 'Chocolate Bar';


    renderModalGallery(
      modalState.images,
      title
    );
  }


  /* ========================================================
     MODAL HELPERS
     ======================================================== */

  function getModalQuantity() {

    if (!modalState.card) {
      return 0;
    }


    const item =
      getItem(
        modalState.card
          .dataset
          .variantId
      );


    return item
      ? item.quantity
      : 0;
  }


  function renderModalQuantity() {

    const quantityEl =
      productModal.querySelector(
        '[data-tsd-shop-modal-quantity]'
      );

    if (quantityEl) {

      quantityEl.textContent =
        getModalQuantity();
    }
  }


  async function openProductModal(
    card,
    trigger
  ) {

    if (!card) {
      return;
    }


    modalState.card =
      card;

    modalState.previousFocus =
      trigger ||
      document.activeElement;

    modalState.images =
      [];

    modalState.activeImage =
      0;


    const title =
      card.dataset.productTitle ||
      'Chocolate Bar';


    const flavor =
      getFlavorName(
        card,
        title
      );


    const price =
      Number(
        card.dataset.productPrice ||
        0
      );


    const fallbackImage =
      getCardImage(
        card
      );


    const titleEl =
      productModal.querySelector(
        '[data-tsd-shop-modal-title]'
      );


    const flavorEl =
      productModal.querySelector(
        '[data-tsd-shop-modal-flavor]'
      );


    const priceEl =
      productModal.querySelector(
        '[data-tsd-shop-modal-price]'
      );


    const descriptionEl =
      productModal.querySelector(
        '[data-tsd-shop-modal-description]'
      );


    if (titleEl) {
      titleEl.textContent =
        title;
    }


    if (flavorEl) {
      flavorEl.textContent =
        flavor;
    }


    if (priceEl) {
      priceEl.textContent =
        money(price);
    }


    if (descriptionEl) {
      descriptionEl.innerHTML =
        '';
    }


    renderModalGallery(
      fallbackImage
        ? [fallbackImage]
        : [],
      title
    );


    renderModalQuantity();


    productModal.classList.add(
      'is-open'
    );


    productModal.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'tsd-shop-modal-open'
    );


    const closeButton =
      productModal.querySelector(
        '.tsd-shop-product-modal__close'
      );


    if (closeButton) {

      window.requestAnimationFrame(
        () => {

          closeButton.focus({
            preventScroll:
              true
          });
        }
      );
    }


    const product =
      await loadProductDetails(
        card,
        title
      );


    if (
      modalState.card !==
        card ||
      !productModal
        .classList
        .contains(
          'is-open'
        )
    ) {

      return;
    }


    if (product) {

      const images =
        normalizeProductImages(
          product,
          fallbackImage
        );


      modalState.activeImage =
        0;


      renderModalGallery(
        images,
        title
      );


      if (
        descriptionEl &&
        product.description
      ) {

        descriptionEl.innerHTML =
          sanitizeDescriptionHtml(
            product.description
          );
      }
    }
  }


  function closeProductModal() {

    if (
      !productModal
        .classList
        .contains(
          'is-open'
        )
    ) {
      return;
    }


    productModal.classList.remove(
      'is-open'
    );


    productModal.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'tsd-shop-modal-open'
    );


    const previousFocus =
      modalState.previousFocus;


    modalState.card =
      null;

    modalState.images =
      [];

    modalState.activeImage =
      0;

    modalState.previousFocus =
      null;


    if (
      previousFocus &&
      typeof previousFocus.focus ===
        'function'
    ) {

      window.requestAnimationFrame(
        () => {

          previousFocus.focus({
            preventScroll: true
          });
        }
      );
    }
  }


  /* ========================================================
     SET ITEM
     ======================================================== */

  function setItem(
    card,
    quantity
  ) {

    if (!card) return;


    const variantId =
      String(
        card.dataset.variantId
      );


    const title =
      card.dataset.productTitle ||
      'Chocolate Bar';


    const price =
      Number(
        card.dataset.productPrice ||
        0
      );


    const flavor =
      getFlavorName(
        card,
        title
      );


    const image =
      getCardImage(
        card
      );


    const safeQuantity =
      Math.max(
        0,
        Math.floor(
          Number(quantity) || 0
        )
      );


    if (
      safeQuantity === 0
    ) {

      state.items.delete(
        variantId
      );

    } else {

      state.items.set(
        variantId,
        {
          variantId,
          title,
          price,
          flavor,
          image,
          quantity:
            safeQuantity
        }
      );
    }


    saveState();

    render();


    if (
      modalState.card &&
      String(
        modalState.card
          .dataset
          .variantId
      ) ===
        variantId
    ) {

      renderModalQuantity();
    }
  }


  /* ========================================================
     PRODUCT CARD QUANTITIES
     ======================================================== */

  function renderProductCards() {

    productCards.forEach(
      (card) => {

        const variantId =
          String(
            card.dataset.variantId
          );


        const item =
          getItem(
            variantId
          );


        const quantityEl =
          card.querySelector(
            '.tsd-qty-value'
          );


        if (quantityEl) {

          quantityEl.textContent =
            item
              ? item.quantity
              : 0;
        }


        card.classList.toggle(
          'has-selection',
          Boolean(
            item &&
            item.quantity > 0
          )
        );
      }
    );
  }


  /* ========================================================
     SELECTED DATES LIST
     ======================================================== */

  function renderSelectedItems() {

    if (!selectedContainer) {
      return;
    }


    selectedContainer.innerHTML =
      '';


    if (
      state.items.size === 0
    ) {

      selectedContainer.innerHTML = `
        <p class="tsd-selection-box__empty">
          Your Dates will appear here as you add them.
        </p>
      `;

      return;
    }


    state.items.forEach(
      (item) => {

        const card =
          getCardByVariantId(
            item.variantId
          );


        const flavor =
          item.flavor ||
          getFlavorName(
            card,
            item.title
          );


        const image =
          item.image ||
          getCardImage(
            card
          );


        const row =
          document.createElement(
            'div'
          );


        row.className =
          'tsd-shop-selected-row';


        row.dataset.variantId =
          item.variantId;


        row.innerHTML = `
          <div class="tsd-shop-selected-row__product">

            ${
              image
                ? `
                  <img
                    class="tsd-shop-selected-row__image"
                    src="${escapeHtml(image)}"
                    alt=""
                    loading="lazy"
                  >
                `
                : ''
            }

            <span class="tsd-shop-selected-row__name">
              ${escapeHtml(flavor)}
            </span>
          </div>

          <div
            class="tsd-shop-selected-row__controls"
            aria-label="Quantity for ${escapeHtml(flavor)}"
          >

            <button
              type="button"
              class="tsd-shop-selected-row__button"
              data-tsd-selected-minus
              aria-label="Decrease ${escapeHtml(flavor)}"
            >
              &minus;
            </button>

            <span
              class="tsd-shop-selected-row__qty"
              aria-live="polite"
            >
              ${item.quantity}
            </span>

            <button
              type="button"
              class="tsd-shop-selected-row__button"
              data-tsd-selected-plus
              aria-label="Increase ${escapeHtml(flavor)}"
            >
              +
            </button>

          </div>
        `;


        selectedContainer.appendChild(
          row
        );
      }
    );
  }


  if (selectedContainer) {

    selectedContainer.addEventListener(
      'click',
      (event) => {

        const button =
          event.target.closest(
            '[data-tsd-selected-minus], [data-tsd-selected-plus]'
          );


        if (!button) {
          return;
        }


        event.preventDefault();

        event.stopPropagation();


        const row =
          button.closest(
            '.tsd-shop-selected-row'
          );


        if (!row) {
          return;
        }


        const variantId =
          String(
            row.dataset.variantId ||
            ''
          );


        const item =
          getItem(
            variantId
          );


        const card =
          getCardByVariantId(
            variantId
          );


        if (
          !item ||
          !card
        ) {
          return;
        }


        const nextQuantity =
          button.hasAttribute(
            'data-tsd-selected-plus'
          )
            ? item.quantity + 1
            : item.quantity - 1;


        setItem(
          card,
          nextQuantity
        );
      }
    );
  }


  /* ========================================================
     LIVE SAVINGS MESSAGE
     ======================================================== */

  function ensureLiveMessage() {

    let live =
      root.querySelector(
        '[data-tsd-shop-live-message]'
      );


    if (live) {
      return live;
    }


    live =
      document.createElement(
        'div'
      );


    live.className =
      'tsd-shop-live-message';


    live.setAttribute(
      'data-tsd-shop-live-message',
      ''
    );


    if (savingsBox) {

      savingsBox.insertAdjacentElement(
        'afterend',
        live
      );

    } else if (addButton) {

      addButton.insertAdjacentElement(
        'beforebegin',
        live
      );
    }


    return live;
  }


  function getMilestoneMessage(
    subtotal
  ) {

    if (subtotal <= 0) {
      return '';
    }


    if (
      state.purchaseType ===
      'subscription'
    ) {

      return (
        'SUBSCRIPTION SAVINGS APPLIED \u2713'
      );
    }


    if (
      subtotal <
      CONFIG.freeShippingThreshold
    ) {

      const remaining =
        CONFIG.freeShippingThreshold -
        subtotal;


      return (
        `${money(remaining)} MORE TO UNLOCK FREE ONTARIO SHIPPING`
      );
    }


    if (
      subtotal <
      CONFIG.fivePercentThreshold
    ) {

      const remaining =
        CONFIG.fivePercentThreshold -
        subtotal;


      return (
        `FREE ONTARIO SHIPPING UNLOCKED \u2713 \u00B7 ${money(remaining)} MORE TO 5% OFF`
      );
    }


    if (
      subtotal <
      CONFIG.tenPercentThreshold
    ) {

      const remaining =
        CONFIG.tenPercentThreshold -
        subtotal;


      return (
        `5% OFF + FREE SHIPPING UNLOCKED \u2713 \u00B7 ${money(remaining)} MORE TO 10% OFF`
      );
    }


    return (
      '10% OFF + FREE SHIPPING UNLOCKED \u2713'
    );
  }


  /* ========================================================
     SUBSCRIPTION NUDGE
     ======================================================== */

  function ensureSubscriptionNudge() {

    let nudge =
      root.querySelector(
        '[data-tsd-subscription-nudge]'
      );


    if (nudge) {
      return nudge;
    }


    nudge =
      document.createElement(
        'div'
      );


    nudge.className =
      'tsd-shop-subscription-nudge';


    nudge.setAttribute(
      'data-tsd-subscription-nudge',
      ''
    );


    const live =
      ensureLiveMessage();


    if (live) {

      live.insertAdjacentElement(
        'afterend',
        nudge
      );

    } else if (addButton) {

      addButton.insertAdjacentElement(
        'beforebegin',
        nudge
      );
    }


    nudge.addEventListener(
      'click',
      (event) => {

        const switchButton =
          event.target.closest(
            '[data-tsd-switch-purchase-type]'
          );


        if (!switchButton) {
          return;
        }


        const requestedType =
          switchButton
            .dataset
            .tsdSwitchPurchaseType;


        if (
          requestedType !==
            'subscription' &&
          requestedType !==
            'onetime'
        ) {

          return;
        }


        state.purchaseType =
          requestedType;


        saveState();

        render();
      }
    );


    return nudge;
  }


  function renderSubscriptionNudge(
    subtotal,
    bars
  ) {

    const nudge =
      ensureSubscriptionNudge();


    if (!nudge) {
      return;
    }


    if (
      bars < 3 ||
      subtotal <= 0
    ) {

      nudge.innerHTML =
        '';

      nudge.hidden =
        true;

      return;
    }


    nudge.hidden =
      false;


    const oneTimePrice =
      getOneTimePrice(
        subtotal
      );


    const firstSubPrice =
      getSubscriptionFirstPrice(
        subtotal
      );


    const recurringSubPrice =
      getSubscriptionRecurringPrice(
        subtotal
      );


    const extraSavingsToday =
      Math.max(
        0,
        oneTimePrice -
        firstSubPrice
      );


    if (
      state.purchaseType ===
      'onetime'
    ) {

      nudge.innerHTML = `
        <p class="tsd-shop-subscription-nudge__eyebrow">
          MAKE IT A REGULAR DATE? &#128527;
        </p>

        <strong class="tsd-shop-subscription-nudge__headline">
          SAVE ${money(extraSavingsToday)} MORE TODAY
        </strong>

        <p class="tsd-shop-subscription-nudge__copy">
          Subscription price today:
          <strong>${money(firstSubPrice)}</strong>
        </p>

        <button
          type="button"
          class="tsd-shop-subscription-nudge__button"
          data-tsd-switch-purchase-type="subscription"
        >
          SWITCH TO SUBSCRIBE & SAVE
        </button>
      `;

      return;
    }


    nudge.innerHTML = `
      <p class="tsd-shop-subscription-nudge__eyebrow">
        SUBSCRIBE & SAVE &#10003;
      </p>

      <strong class="tsd-shop-subscription-nudge__headline">
        ${money(firstSubPrice)} TODAY
      </strong>

      <p class="tsd-shop-subscription-nudge__copy">
        Recurring order:
        <strong>${money(recurringSubPrice)}</strong>
      </p>

      <button
        type="button"
        class="tsd-shop-subscription-nudge__button tsd-shop-subscription-nudge__button--secondary"
        data-tsd-switch-purchase-type="onetime"
      >
        SWITCH BACK TO ONE-TIME
      </button>
    `;
  }


  /* ========================================================
     ADD BUTTON
     ======================================================== */

  function renderAddButton(
    subtotal,
    bars
  ) {

    if (!addButton) {
      return;
    }


    if (bars <= 0) {

      addButton.disabled =
        true;


      addButton.textContent =
        'ADD YOUR DATES';


      return;
    }


    addButton.disabled =
      false;


    const displayPrice =
      state.purchaseType ===
      'subscription'
        ? getSubscriptionFirstPrice(
            subtotal
          )
        : getOneTimePrice(
            subtotal
          );


    addButton.textContent =
      state.purchaseType ===
      'subscription'
        ? `ADD SUBSCRIPTION \u2014 ${money(displayPrice)}`
        : `ADD YOUR DATES \u2014 ${money(displayPrice)}`;
  }


  /* ========================================================
     MAIN RENDER
     ======================================================== */

  function render() {

    const bars =
      getTotalBars();


    const subtotal =
      getRetailSubtotal();


    renderProductCards();

    renderSelectedItems();


    if (barCountEl) {

      barCountEl.textContent =
        bars;
    }


    if (subtotalEl) {

      subtotalEl.textContent =
        money(
          subtotal
        );
    }


    const live =
      ensureLiveMessage();


    if (live) {

      const message =
        getMilestoneMessage(
          subtotal
        );


      live.textContent =
        message;


      live.hidden =
        !message;
    }


    renderSubscriptionNudge(
      subtotal,
      bars
    );


    renderAddButton(
      subtotal,
      bars
    );
      updateShopMobileStickyBar();
    }


  /* ========================================================
     PRODUCT MODAL EVENTS
     ======================================================== */

  productModal.addEventListener(
    'click',
    (event) => {

      if (
        event.target.closest(
          '[data-tsd-shop-modal-close]'
        )
      ) {

        closeProductModal();

        return;
      }


      if (!modalState.card) {
        return;
      }


      const thumbnail =
        event.target.closest(
          '[data-tsd-shop-modal-thumb]'
        );


      if (thumbnail) {

        showModalImage(
          Number(
            thumbnail.getAttribute(
              'data-tsd-shop-modal-thumb'
            )
          )
        );

        return;
      }


      if (
        event.target.closest(
          '[data-tsd-shop-modal-prev]'
        )
      ) {

        showModalImage(
          modalState.activeImage - 1
        );

        return;
      }


      if (
        event.target.closest(
          '[data-tsd-shop-modal-next]'
        )
      ) {

        showModalImage(
          modalState.activeImage + 1
        );

        return;
      }


      if (
        event.target.closest(
          '[data-tsd-shop-modal-minus]'
        )
      ) {

        const quantity =
          getModalQuantity();


        setItem(
          modalState.card,
          Math.max(
            0,
            quantity - 1
          )
        );


        return;
      }


      if (
        event.target.closest(
          '[data-tsd-shop-modal-plus]'
        )
      ) {

        const quantity =
          getModalQuantity();


        setItem(
          modalState.card,
          quantity + 1
        );
      }
    }
  );


  document.addEventListener(
    'keydown',
    (event) => {

      const modalOpen =
        productModal
          .classList
          .contains(
            'is-open'
          );


      if (!modalOpen) {
        return;
      }


      if (
        event.key ===
          'Escape'
      ) {

        closeProductModal();

        return;
      }


      if (
        event.key ===
          'ArrowLeft'
      ) {

        showModalImage(
          modalState.activeImage - 1
        );

        return;
      }


      if (
        event.key ===
          'ArrowRight'
      ) {

        showModalImage(
          modalState.activeImage + 1
        );
      }
    }
  );


  /* ========================================================
     PRODUCT CARD EVENTS
     ======================================================== */

  productCards.forEach(
    (card) => {

      const plus =
        card.querySelector(
          '.tsd-qty-plus'
        );


      const minus =
        card.querySelector(
          '.tsd-qty-minus'
        );


      const productImage =
        card.querySelector(
          'img'
        );


      if (productImage) {

        productImage.style.cursor =
          'pointer';


        productImage.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            openProductModal(
              card,
              productImage
            );
          }
        );
      }


      if (plus) {

        plus.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            const variantId =
              String(
                card.dataset.variantId
              );


            const current =
              getItem(
                variantId
              );


            setItem(
              card,
              current
                ? current.quantity + 1
                : 1
            );
          }
        );
      }


      if (minus) {

        minus.addEventListener(
          'click',
          (event) => {

            event.preventDefault();

            event.stopPropagation();


            const variantId =
              String(
                card.dataset.variantId
              );


            const current =
              getItem(
                variantId
              );


            if (!current) {
              return;
            }


            setItem(
              card,
              current.quantity - 1
            );
          }
        );
      }
    }
  );


  /* ========================================================
     SHOPIFY CART HELPERS
     ======================================================== */

  function getShopRoot() {

    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    )
      ? window.Shopify.routes.root
      : '/';
  }


  async function fetchCart() {

    const response =
      await fetch(
        `${getShopRoot()}cart.js`,
        {
          method: 'GET',

          headers: {
            'Accept':
              'application/json'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        `Could not read cart (${response.status})`
      );
    }


    return response.json();
  }


  function lineMatchesPurchaseType(
    line,
    purchaseType
  ) {

    const plan =
      line &&
      line.selling_plan_allocation &&
      line.selling_plan_allocation
        .selling_plan;


    const planId =
      plan
        ? Number(
            plan.id
          )
        : null;


    if (
      purchaseType ===
      'subscription'
    ) {

      return (
        planId ===
        CONFIG.sellingPlanId
      );
    }


    return !planId;
  }


  /*
    IMPORTANT FIX:
    Shopify cart/change.js accepts the 1-based cart line number.

    We deliberately use:
      line: 1
      line: 2
      etc.

    This avoids the invalid id / line-key problem that caused
    the 400 error when switching between one-time and subscription.
  */

  async function changeCartLine(
    lineNumber,
    quantity
  ) {

    const safeLineNumber =
      Number(
        lineNumber
      );


    if (
      !Number.isInteger(
        safeLineNumber
      ) ||
      safeLineNumber < 1
    ) {

      throw new Error(
        'Could not update cart: invalid cart line number.'
      );
    }


    const response =
      await fetch(
        `${getShopRoot()}cart/change.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify({
              line:
                safeLineNumber,

              quantity:
                Number(
                  quantity
                )
            })
        }
      );


    if (!response.ok) {

      const errorText =
        await response.text();


      throw new Error(
        `Could not update cart (${response.status}): ${errorText}`
      );
    }


    return response.json();
  }


  async function addCartItems(
    items
  ) {

    if (!items.length) {
      return;
    }


    const response =
      await fetch(
        `${getShopRoot()}cart/add.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify({
              items
            })
        }
      );


    if (!response.ok) {

      const errorText =
        await response.text();


      throw new Error(
        `Could not add products (${response.status}): ${errorText}`
      );
    }


    return response.json();
  }


  /* ========================================================
     COMMIT SHOP SELECTION TO REAL CART

     IMPORTANT:

     - Unrelated cart products remain untouched.
     - Existing opposite purchase-type version is removed.
     - Existing same-type version gets exact selected quantity.
     - Shopify cart is re-read after removals because line
       numbers shift when a line disappears.
     ======================================================== */

  async function commitSelectionToCart() {

    /*
      Freeze the customer's intent at the exact moment
      they press the cart button.

      Even if something else changes on screen while Shopify
      is processing, this cart build will use one consistent
      set of quantities and one consistent purchase type.
    */

    const selectedItems =
      Array.from(
        state.items.values()
      )
        .filter(
          (item) => {
            return (
              item &&
              item.variantId &&
              Number(item.quantity) > 0
            );
          }
        )
        .map(
          (item) => {
            return {
              variantId:
                String(
                  item.variantId
                ),

              quantity:
                Math.max(
                  1,
                  Math.floor(
                    Number(
                      item.quantity
                    ) || 1
                  )
                )
            };
          }
        );


    const purchaseType =
      state.purchaseType;


    if (!selectedItems.length) {
      return;
    }


    /*
      IMPORTANT FIX:

      We remove EVERY The Simple Date Shop product currently
      sitting in the Shopify cart first — not merely the
      products that happen to be selected right now.

      This prevents an old subscription line from surviving
      after the customer removes a flavour, changes quantities,
      or switches back to one-time.

      Unrelated Shopify cart products are left completely alone.
    */

    const allShopVariantIds =
      new Set(
        productCards.map(
          (card) => {
            return String(
              card.dataset.variantId
            );
          }
        )
      );


    const currentCart =
      await fetchCart();


    const updates =
      {};


    currentCart.items.forEach(
      (line) => {

        const variantId =
          String(
            line.variant_id
          );


        if (
          allShopVariantIds.has(
            variantId
          ) &&
          line.key
        ) {

          updates[
            line.key
          ] = 0;
        }
      }
    );


    /*
      Shopify cart/update.js lets us remove all old Shop
      lines in ONE request by using their current line keys.

      That means there are no shifting line numbers and no
      stale one-time/subscription copies left behind.
    */

    if (
      Object.keys(
        updates
      ).length > 0
    ) {

      const removeResponse =
        await fetch(
          `${getShopRoot()}cart/update.js`,
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              'Accept':
                'application/json'
            },

            body:
              JSON.stringify({
                updates
              })
          }
        );


      if (!removeResponse.ok) {

        const removeError =
          await removeResponse.text();


        throw new Error(
          `Could not clean existing Shop cart items (${removeResponse.status}): ${removeError}`
        );
      }
    }


    /*
      Rebuild the customer's CURRENT Shop selection from
      scratch in one single purchase type.
    */

    const cartItems =
      selectedItems.map(
        (item) => {

          const cartItem = {
            id:
              Number(
                item.variantId
              ),

            quantity:
              item.quantity
          };


          if (
            purchaseType ===
            'subscription'
          ) {

            cartItem.selling_plan =
              CONFIG.sellingPlanId;
          }


          return cartItem;
        }
      );


    await addCartItems(
      cartItems
    );


    /*
      FINAL VERIFICATION

      Read Shopify's real cart back and make sure:
      1. every selected Shop product is present,
      2. quantities are exact,
      3. every selected line is the requested purchase type,
      4. no old unselected Shop product survived.
    */

    const finalCart =
      await fetchCart();


    const expected =
      new Map(
        selectedItems.map(
          (item) => {
            return [
              String(
                item.variantId
              ),
              item.quantity
            ];
          }
        )
      );


    const actual =
      new Map();


    finalCart.items.forEach(
      (line) => {

        const variantId =
          String(
            line.variant_id
          );


        if (
          !allShopVariantIds.has(
            variantId
          )
        ) {

          return;
        }


        const existing =
          actual.get(
            variantId
          ) || {
            quantity: 0,
            correctType: true
          };


        existing.quantity +=
          Number(
            line.quantity || 0
          );


        if (
          !lineMatchesPurchaseType(
            line,
            purchaseType
          )
        ) {

          existing.correctType =
            false;
        }


        actual.set(
          variantId,
          existing
        );
      }
    );


    if (
      actual.size !==
      expected.size
    ) {

      throw new Error(
        'The cart did not rebuild cleanly. Please try again.'
      );
    }


    for (
      const [
        variantId,
        expectedQuantity
      ] of expected
    ) {

      const actualItem =
        actual.get(
          variantId
        );


      if (
        !actualItem ||
        actualItem.quantity !==
          expectedQuantity ||
        !actualItem.correctType
      ) {

        throw new Error(
          'The cart could not be verified. Please try again.'
        );
      }
    }
  }


  /* ========================================================
     ADD YOUR DATES BUTTON
     ======================================================== */

  if (addButton) {

    addButton.addEventListener(
      'click',
      async (event) => {

        event.preventDefault();

        event.stopImmediatePropagation();


        if (
          getTotalBars() <= 0
        ) {

          return;
        }


        const originalText =
          addButton.textContent;


        saveState();


        addButton.disabled =
          true;


        addButton.classList.add(
          'tsd-shop-button--loading'
        );


        addButton.innerHTML = `
          <span
            class="tsd-shop-button__spinner"
            aria-hidden="true"
          ></span>

          <span>
            BUILDING YOUR CART
          </span>
        `;


        try {

          await commitSelectionToCart();


          /*
            SHOP remains the low-pressure path:
            go to Shopify cart rather than straight to checkout.
          */

          window.location.href =
            `${getShopRoot()}cart`;


        } catch (error) {

          console.error(
            'TSD Shop cart error:',
            error
          );


          alert(
            'We could not add your Dates.\n\n' +
            (
              error &&
              error.message
                ? error.message
                : String(error)
            )
          );


          addButton.disabled =
            false;


          addButton.classList.remove(
            'tsd-shop-button--loading'
          );


          addButton.textContent =
            originalText;
        }
      }
    );
  }


  /* ========================================================
     SUPPORTING STYLES
     ======================================================== */

  function injectStyles() {

    if (
      document.getElementById(
        'tsd-shop-js-styles'
      )
    ) {

      return;
    }


    const style =
      document.createElement(
        'style'
      );


    style.id =
      'tsd-shop-js-styles';


    style.textContent = `

      body.tsd-shop-modal-open {
        overflow: hidden;
      }


      /* ==========================
         PRODUCT MODAL
         ========================== */

      .tsd-shop-product-modal {
        position: fixed;
        inset: 0;
        z-index: 9999;

        display: none;
        align-items: center;
        justify-content: center;

        padding: 24px;
      }


      .tsd-shop-product-modal.is-open {
        display: flex;
      }


      .tsd-shop-product-modal__backdrop {
        position: absolute;
        inset: 0;

        background:
          rgba(0, 0, 0, 0.58);
      }


      .tsd-shop-product-modal__dialog {
        position: relative;
        z-index: 1;

        width:
          min(
            880px,
            94vw
          );

        max-height: 90vh;

        overflow: auto;

        border-radius: 20px;

        background:
          #ffffff;

        box-shadow:
          0 24px 70px
          rgba(0, 0, 0, 0.24);
      }


      .tsd-shop-product-modal__close {
        position: absolute;
        z-index: 3;

        top: 16px;
        right: 16px;

        width: 40px;
        height: 40px;

        padding: 0;

        border:
          1px solid
          rgba(18, 18, 18, 0.14);

        border-radius: 50%;

        background:
          #ffffff;

        color:
          #29252f;

        cursor: pointer;

        font-size: 28px;
        line-height: 1;
      }


      .tsd-shop-product-modal__content {
        display: grid;

        grid-template-columns:
          minmax(0, 1.25fr)
          minmax(280px, 0.75fr);

        min-height: 520px;
      }


      .tsd-shop-product-modal__media {
        display: flex;
        align-items: center;
        justify-content: center;

        padding:
          38px;

        background:
          #f7f5f6;
      }


      .tsd-shop-product-modal__image {
        width: 100%;

        max-width: 520px;

        max-height: 68vh;

        object-fit: contain;

        border-radius: 14px;
      }


      .tsd-shop-product-modal__info {
        display: flex;
        flex-direction: column;

        padding:
          72px
          38px
          38px;
      }


      .tsd-shop-product-modal__eyebrow {
        margin:
          0 0 10px;

        color:
          #d5267b;

        font-size:
          1.05rem;

        line-height:
          1.2;

        font-weight:
          800;

        letter-spacing:
          0.08em;
      }


      .tsd-shop-product-modal__title {
        margin:
          0 0 8px;

        color:
          #29252f;

        font-size:
          clamp(
            2.4rem,
            3vw,
            3.8rem
          );

        line-height:
          1.05;
      }


      .tsd-shop-product-modal__flavor {
        margin:
          0 0 12px;

        color:
          #706b73;

        font-size:
          1.35rem;
      }


      .tsd-shop-product-modal__price {
        margin: 0;

        color:
          #29252f;

        font-size:
          1.35rem;

        font-weight:
          700;
      }


      .tsd-shop-product-modal__quantity-wrap {
        margin-top: auto;

        padding-top:
          36px;
      }


      .tsd-shop-product-modal__quantity-label {
        display: block;

        margin-bottom:
          10px;

        color:
          #706b73;

        font-size:
          1rem;

        font-weight:
          800;

        letter-spacing:
          0.05em;
      }


      .tsd-shop-product-modal__quantity {
        display:
          inline-flex;

        align-items:
          center;

        overflow:
          hidden;

        border:
          1px solid
          rgba(18, 18, 18, 0.18);

        border-radius:
          999px;
      }


      .tsd-shop-product-modal__qty-button {
        width:
          44px;

        height:
          42px;

        padding:
          0;

        border:
          0;

        background:
          transparent;

        color:
          #29252f;

        cursor:
          pointer;

        font:
          inherit;

        font-size:
          20px;

        line-height:
          1;
      }


      .tsd-shop-product-modal__qty-value {
        min-width:
          42px;

        text-align:
          center;

        font-size:
          1.25rem;

        font-weight:
          700;
      }


      /* ==========================
         RICH PRODUCT MODAL GALLERY
         ========================== */

      .tsd-shop-product-modal__media {
        display: grid;
        grid-template-columns:
          62px minmax(0, 1fr);
        gap: 16px;
        align-items: center;
      }

      .tsd-shop-product-modal__thumbs {
        display: flex;
        flex-direction: column;
        gap: 9px;
        align-self: stretch;
        justify-content: flex-start;
        max-height: 540px;
        overflow-y: auto;
        padding: 2px;
      }

      .tsd-shop-product-modal__thumb {
        width: 56px;
        height: 56px;
        padding: 0;
        overflow: hidden;
        border:
          1px solid
          rgba(41, 37, 47, 0.15);
        border-radius: 8px;
        background: #ffffff;
        cursor: pointer;
      }

      .tsd-shop-product-modal__thumb.is-active {
        border:
          2px solid
          #29252f;
      }

      .tsd-shop-product-modal__thumb img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .tsd-shop-product-modal__stage {
        position: relative;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tsd-shop-product-modal__arrow {
        position: absolute;
        z-index: 3;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background:
          rgba(255, 255, 255, 0.94);
        color: #29252f;
        box-shadow:
          0 3px 12px
          rgba(41, 37, 47, 0.14);
        cursor: pointer;
        font: inherit;
        font-size: 28px;
        line-height: 1;
      }

      .tsd-shop-product-modal__arrow--prev {
        left: 10px;
      }

      .tsd-shop-product-modal__arrow--next {
        right: 10px;
      }

      .tsd-shop-product-modal__description {
        margin-top: 24px;
        color: #29252f;
        font-size: 1.35rem;
        line-height: 1.5;
      }

      .tsd-shop-product-modal__description > :first-child {
        margin-top: 0;
      }

      .tsd-shop-product-modal__description > :last-child {
        margin-bottom: 0;
      }


      /* ==========================
         RIGHT-HAND SELECTOR
         ========================== */

      .tsd-shop-selected-row {
        display: flex;

        align-items: center;

        justify-content:
          space-between;

        gap:
          12px;

        padding:
          9px 0;

        border-bottom:
          1px solid
          rgba(18, 18, 18, 0.10);

        font-size:
          1.25rem;

        line-height:
          1.35;
      }


      .tsd-shop-selected-row:last-child {
        border-bottom: 0;
      }


      .tsd-shop-selected-row__product {
        display: flex;

        align-items:
          center;

        gap:
          9px;

        min-width:
          0;
      }


      .tsd-shop-selected-row__image {
        width:
          42px;

        height:
          42px;

        flex:
          0 0 42px;

        border-radius:
          7px;

        object-fit:
          cover;

        display:
          block;
      }


      .tsd-shop-selected-row__name {
        min-width:
          0;

        font-weight:
          700;
      }


      .tsd-shop-selected-row__controls {
        display:
          inline-flex;

        align-items:
          center;

        flex:
          0 0 auto;

        overflow:
          hidden;

        border:
          1px solid
          rgba(18, 18, 18, 0.18);

        border-radius:
          999px;
      }


      .tsd-shop-selected-row__button {
        width:
          32px;

        height:
          30px;

        padding:
          0;

        border:
          0;

        background:
          transparent;

        color:
          inherit;

        cursor:
          pointer;

        font:
          inherit;

        line-height:
          1;
      }


      .tsd-shop-selected-row__button:hover {
        background:
          rgba(18, 18, 18, 0.05);
      }


      .tsd-shop-selected-row__qty {
        min-width:
          30px;

        text-align:
          center;

        font-weight:
          700;
      }


      /* ==========================
         BUILDING CART SPINNER
         ========================== */

      .tsd-shop-button--loading {
        position: relative;

        display:
          inline-flex;

        align-items:
          center;

        justify-content:
          center;

        gap:
          9px;

        cursor:
          wait;
      }


      .tsd-shop-button--loading::before,
      .tsd-shop-button--loading::after {
        content:
          none !important;

        display:
          none !important;
      }


      .tsd-shop-button--loading .tsd-shop-button__spinner {
        display:
          inline-block !important;

        box-sizing:
          border-box;

        width:
          16px;

        height:
          16px;

        flex:
          0 0 16px;

        border:
          2px solid
          currentColor;

        border-right-color:
          transparent;

        border-radius:
          50%;

        animation:
          tsd-shop-spin
          0.7s
          linear
          infinite;
      }


      @keyframes tsd-shop-spin {
        to {
          transform:
            rotate(360deg);
        }
      }


      /* ==========================
         EXISTING SHOP MESSAGES
         ========================== */

      .tsd-shop-live-message {
        margin-top:
          14px;

        padding:
          11px 12px;

        border-radius:
          10px;

        background:
          rgba(213, 38, 123, 0.06);

        font-size:
          1.15rem;

        line-height:
          1.35;

        font-weight:
          700;
      }


      .tsd-shop-subscription-nudge {
        margin-top:
          14px;

        padding:
          15px;

        border:
          1px solid
          rgba(213, 38, 123, 0.18);

        border-radius:
          12px;

        background:
          #ffffff;
      }


      .tsd-shop-subscription-nudge__eyebrow {
        margin:
          0 0 7px;

        color:
          #d5267b;

        font-size:
          1.05rem;

        line-height:
          1.2;

        font-weight:
          700;

        letter-spacing:
          0.08em;
      }


      .tsd-shop-subscription-nudge__headline {
        display:
          block;

        margin-bottom:
          5px;

        font-size:
          1.45rem;

        line-height:
          1.2;
      }


      .tsd-shop-subscription-nudge__copy {
        margin:
          0;

        font-size:
          1.15rem;

        line-height:
          1.4;
      }


      .tsd-shop-subscription-nudge__button {
        width:
          100%;

        margin-top:
          11px;

        padding:
          10px 12px;

        border:
          0;

        border-radius:
          999px;

        background:
          #d5267b;

        color:
          #ffffff;

        cursor:
          pointer;

        font:
          inherit;

        font-size:
          1.05rem;

        font-weight:
          700;
      }


      .tsd-shop-subscription-nudge__button--secondary {
        border:
          1px solid
          rgba(18, 18, 18, 0.18);

        background:
          #ffffff;

        color:
          rgb(
            var(
              --color-foreground
            )
          );
      }


      /* ==========================
         MOBILE
         ========================== */

      @media screen and (max-width: 749px) {

        .tsd-shop-product-modal {
          padding:
            12px;
        }


        .tsd-shop-product-modal__dialog {
          width:
            100%;

          max-height:
            92vh;

          border-radius:
            16px;
        }


        .tsd-shop-product-modal__content {
          grid-template-columns:
            1fr;

          min-height:
            0;
        }


        .tsd-shop-product-modal__media {
          padding:
            28px
            22px
            20px;
        }


        .tsd-shop-product-modal__image {
          max-height:
            46vh;
        }


        .tsd-shop-product-modal__info {
          padding:
            26px
            22px
            28px;
        }


        .tsd-shop-product-modal__quantity-wrap {
          margin-top:
            24px;

          padding-top:
            0;
        }


        .tsd-shop-product-modal__media {
          grid-template-columns:
            48px minmax(0, 1fr);

          gap:
            10px;
        }


        .tsd-shop-product-modal__thumb {
          width:
            44px;

          height:
            44px;
        }


        .tsd-shop-product-modal__thumbs {
          max-height:
            46vh;
        }


        .tsd-shop-product-modal__arrow {
          width:
            34px;

          height:
            34px;

          font-size:
            24px;
        }


        .tsd-shop-product-modal__description {
          font-size:
            1.25rem;
        }


        .tsd-shop-selected-row {
          font-size:
            1.2rem;
        }


        .tsd-shop-live-message {
          font-size:
            1.1rem;
        }
      }
    `;


    document.head.appendChild(
      style
    );
  }

  window.addEventListener(
    'scroll',
    updateShopStickyVisibility,
    {
      passive: true
    }
  );


  window.addEventListener(
    'resize',
    refreshShopMobileSticky
  );


  if (
    typeof mobileQuery.addEventListener ===
    'function'
  ) {

    mobileQuery.addEventListener(
      'change',
      refreshShopMobileSticky
    );

  } else if (
    typeof mobileQuery.addListener ===
    'function'
  ) {

    mobileQuery.addListener(
      refreshShopMobileSticky
    );
  }
  /* ========================================================
     INITIALIZE
     ======================================================== */

  injectStyles();
  injectShopMobileStickyStyles();

  ensureShopMobileStickyBar();
  saveState();

  render();


  /*
    Browser Back / Forward restoration.
  */

  window.addEventListener(
    'pageshow',
    () => {

      render();
    }
  );

})();